import { getDate } from "@/helpers/date.helpers"
import { RESOURCES } from "@/organisms/Form"
import { FREQUENCY } from "@/pages/ReportsPage/const"

import type { getReportDefinition } from "@/pages/ReportsPage/applications/useReports.selector"

export const getInitialValues = (
  data:
    | (ReturnType<typeof getReportDefinition>["data"][number] & {
        isAllResources: boolean
      })[]
    | undefined,
  isNew?: boolean,
  createDuplicate?: boolean
) => {
  const every = 1
  const getTime = (
    hours: number | string | undefined,
    minutes: number | string | undefined
  ) =>
    getDate()
      .hour(Number(hours || 9))
      .minute(Number(minutes || 0))
      .second(0)
      .millisecond(0)

  if (isNew && !createDuplicate)
    return {
      every,
      resources: RESOURCES.ALL,
      frequency: FREQUENCY.ONCE,
      time: getTime(9, 0)
    }

  if (!data?.length) return {}

  const {
    name,
    description,
    scopes,
    schedule,
    frequency,
    isAllResources,
    ...rest
  } = data[0]

  const [unit, frequencyDetails] = frequency
  const { hours, minutes, days } = frequencyDetails || {}

  return {
    every,
    unit,
    days,
    name_details: name,
    description_details: description,
    frequency: !schedule ? FREQUENCY.ONCE : FREQUENCY.REPEATING,
    resources: isAllResources ? RESOURCES.ALL : RESOURCES.SPECIFIC,
    specificScopes: isAllResources ? undefined : scopes[0],
    time: getTime(hours, minutes),
    ...rest
  }
}

export const isOnce = (frequency: (typeof FREQUENCY)[keyof typeof FREQUENCY]) =>
  frequency === FREQUENCY.ONCE
